export const environment = {
  production: false,
  enableLogging: true,
  logLevel: 'debug'
};
